<template>
  <div class="templateSetting">
    <!-- 修改合同模板弹窗-->
    <el-dialog
      title="设置合同模板"
      :visible.sync="isDialogShow"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form label-width="120px" ref="deptForm">
        <el-row>
          <el-col :span="22">
            <el-form-item label="请选择合同模板" prop="resource">
              <el-radio-group v-model="templateType">
                <el-radio
                  v-for="item in list"
                  :label="item.value"
                  :key="item.value"
                  style="width: 160px; margin: 10px 0"
                >{{ item.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="saveTemplateClick()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "templateSetting",
  data() {
    return {
      isDialogShow: false,
      templateType: "",
      list: [],
      //LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
      laborlist: [{ name: "默认合同模板", value: "LaborContract" }],
      materiallist: [
        { value: "MaterialProcurementTotalContract", name: "总价合同" },
        { value: "MaterialProcurementContract", name: "单价合同" },
      ],
      machinelist: [
        { value: "carriageContract", name: "默认合同模板" },
        { value: "mudMixContract", name: "稳定土拌合加工合同" },
        { value: "asphaltMixContract", name: "沥青拌合加工合同" },
        { value: "concretMixContract", name: "混凝土拌合加工运输合同" },
        { value: "transportContract", name: "拌合料运输合同" },
        { value: "machinLeaseContract", name: "机械租赁合同" },
        { value: "concreteMakeMixContract", name: "混凝土拌合加工合同" },
        { value: "transportbhlContract", name: "运输合同—适用于各种拌合料" },
      ],
      otherslist: [
        // { value: "otherContract", name: "默认合同模板" },
        { value: "LaborContract", name: "劳务合同模板" },
        { value: "carRentalContract", name: "汽车租赁合同" },
        { value: "MaterialProcurementTotalContract", name: "总价合同" },
        { value: "MaterialProcurementContract", name: "单价合同" },
        { value: "carriageContract", name: "运输合同" },
        { value: "mudMixContract", name: "稳定土拌合加工合同" },
        { value: "asphaltMixContract", name: "沥青拌合加工合同" },
        { value: "concretMixContract", name: "混凝土拌合加工运输合同" },
        { value: "transportContract", name: "拌合料运输合同" },
        { value: "machinLeaseContract", name: "机械租赁合同" },
        { value: "concreteMakeMixContract", name: "混凝土拌合加工合同" },
        { value: "transportbhlContract", name: "运输合同—适用于各种拌合料" },
        { value: "noTemplate", name: "无合同模板的合同" },
      ],
    };
  },
  created() {
    //获取项目部
    // this.getDept();
  },
  methods: {
    showDialog(type,templateType) {
      // this.userCode = sessionStorage.getItem("currentUserId");
      switch (type) {
        case "LABOR":
          this.list = this.laborlist;
          break;
        case "MATERIAL":
          this.list = this.materiallist;
          break;
        case "MACHINE":
          this.list = this.machinelist;
          break;
        case "OTHERS":
          this.list = this.otherslist;
          break;
        default:
          break;
      }
      this.templateType=templateType
      this.isDialogShow = true;
    },
    saveTemplateClick() {
      this.$message.success("已切换合同模板");
      this.isDialogShow = false;
      this.$emit("saveTemplateFun", this.templateType);
    },
  },
};
</script>

<style scoped lang="scss">
.templateSetting {
  /deep/.el-dialog {
    /deep/.el-icon-view:before {
      display: none;
    }
  }
  /deep/.el-select {
    width: 100%;
  }
}
</style>
